import { SocialIcon } from '@anytag/shared-atoms';
import { TextField, TextFieldProps } from '@anytag/shared-molecules';
import { SupportedSocialMediaType } from '@anytag/shared-types';

export interface SocialMediaInputFieldProps<T extends string = string>
  extends Omit<TextFieldProps<T>, 'leftSection' | 'rightSection'> {
  unit?: string | null;
  socialMedia: keyof typeof SupportedSocialMediaType;
}

export const SocialMediaInputField = <T extends string>({
  unit,
  socialMedia,
  ...restProps
}: SocialMediaInputFieldProps<T>) => (
  <TextField<T>
    {...restProps}
    leftSection={<SocialIcon type={socialMedia} />}
    rightSection={unit ? <span className="text-sm text-zinc-500">{unit}</span> : undefined}
    triggerFormRevalidation
  />
);
